// Short display names for CMS payment types
export const PAYMENT_TYPE_LABELS = {
  "Compensation for services other than consulting, including serving as faculty or as a speaker at a venue other than a continuing education program":
    "Speaking/Faculty Fee (non-education)",
  "Consulting Fee": "Consulting Fee",
  "Honoraria": "Honoraria",
  "Food and Beverage": "Food & Beverage",
  "Travel and Lodging": "Travel & Lodging",
  "Education": "Education",
  "Research": "Research",
  "Gift": "Gift",
  "Entertainment": "Entertainment",
  "Royalty or License": "Royalty/License",
  "Current or prospective ownership or investment interest":
    "Ownership or Investment Interest",
  "Compensation for serving as faculty or as a speaker for a medical education program":
    "Faculty or Medical Education Speaker",
  "Grant": "Grant",
  "Charitable Contribution": "Charitable Contribution",
  "Space rental or facility fees (Teaching Hospital only)":
    "Space/Facility Fee",
};

// Full descriptions for tooltips — short name shown, full description on hover
export const PAYMENT_TYPE_DESCRIPTIONS = {
  "Compensation for services other than consulting, including serving as faculty or as a speaker at a venue other than a continuing education program":
    "Payment for speaking or faculty services at a non-continuing education venue, such as conferences or promotional events.",
  "Consulting Fee":
    "Payment for providing consulting services, advice, or expertise to the company.",
  "Honoraria":
    "A payment given for professional services for which custom or propriety forbids a price to be set.",
  "Food and Beverage":
    "Meals or beverages provided to the provider, including at conferences or office visits.",
  "Travel and Lodging":
    "Reimbursement or payment for travel expenses, hotel stays, or transportation.",
  "Education":
    "Payment associated with educational activities, such as continuing medical education programs.",
  "Research":
    "Payment related to research activities conducted by the provider.",
  "Gift":
    "A physical item or non-cash gift provided to the provider.",
  "Entertainment":
    "Payment for entertainment activities such as sporting events or concerts.",
  "Royalty or License":
    "Payment for the use of intellectual property, patents, or licensed materials.",
  "Current or prospective ownership or investment interest":
    "Compensation related to an ownership stake or investment in the reporting company.",
  "Compensation for serving as faculty or as a speaker for a medical education program":
    "Payment for serving as faculty or a speaker at an accredited continuing medical education program.",
  "Grant":
    "Funding provided to support a specific project, research, or educational activity.",
  "Charitable Contribution":
    "A donation made on behalf of the provider to a charitable organization.",
  "Space rental or facility fees (Teaching Hospital only)":
    "Fees paid to a teaching hospital for use of space or facilities.",
};

export function getPaymentTypeLabel(type) {
  return PAYMENT_TYPE_LABELS[type] || type;
}

export function getPaymentTypeDescription(type) {
  return PAYMENT_TYPE_DESCRIPTIONS[type] || type;
}